export enum Local {
  DE_DE = 'de-DE',
  EN_US = 'en-US',
  ES_ES = 'es-ES',
}

export enum QueryLocale {
  DE = 'de',
  EN = 'en',
  ES = 'es',
}

export type LanguageCode = 'de' | 'en' | 'es';

export const getLanguage = (local: Local): LanguageCode =>
  new Intl.Locale(local).language as LanguageCode;
